var m = require('mithril');
var edit = require('../../layout/components/edit');
var heading = require('../../components/heading');
var columnForm = require('../../data/components/columnModal');
var charwithpointText = require('./chartwithpointText')
var helpModal = require('../../help/helpModal');

var charWithPoint ={}

function getPointWriteParentRid (elementRecord) {
  var locationRecord = elementRecord && elementRecord.location && elementRecord.location();
  return locationRecord && locationRecord['@class'] === 'Dashboard'
    ? elementRecord.parentRid
    : elementRecord && elementRecord['@rid'];
}

charWithPoint.oninit = function(vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
}

charWithPoint.view = function(vnode) {
  var ctrl = this;
    return m('div', [
      m(heading, {
        label: ctrl.element.name, 
        class: 'f1', 
        element: ctrl.element, 
        parentReinitialize: ctrl.parentReinitialize, 
        dashboardCallback: ctrl.dashboardCallback,
        datasetRepresentation: vnode.attrs.datasetRepresentation
      }, [
        ctrl.element.helpText ?
          m('i.ion-ios-information-outline.white.f1.ml2', {
            onclick: () => {
              helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.helpText);
            }
          })
        :
          ''
      ]),
      ctrl.element.out_Contains.map(function (outEdge) {
        var dataset = outEdge.in;
        if (ctrl.element.path) {
          dataset.path = [...ctrl.element.path];
        } else {
          dataset.path = [];
        }
        if (!Array.isArray(dataset.out_Column)) {
          dataset.out_Column = []
        }
        if (edit.vm.editing() && dataset.out_Column.length == 0){
          return m('div.tc.pv2', [
            m('i.icon.icon-right.ion-plus.blue', {
              onclick: columnForm.editDialogue.bind(columnForm, {out: dataset['@rid'], path: dataset.path}, { submitCallback: ctrl.parentReinitialize, columnNameRequired: true })
            })
          ])
        }
        if (!edit.vm.editing() && dataset.out_Column.length == 0 && vnode.attrs.datasetRepresentation) {
          return m('table.w-100', {style: {tableLayout: 'fixed'}}, [
            m('tbody', [
              (dataset.columns || []).map(function (column, jdx) {
                return m('tr.bb', [
                  m('td.f3.man.bb.tl.moon-gray.w-50.truncate',  column.name),
                  m('td.f3.man.bb.tl.moon-gray.w-50', '') 
                ])
              })
            ])
          ])
        }
        return(
          dataset.out_Column.map(function (column) {
            column.permission = ctrl.element.permission;
            column.path = dataset.path;
            return m(charwithpointText, {columnRecord: column, element: ctrl.element, parentReinitialize: ctrl.parentReinitialize, parentRid: getPointWriteParentRid(ctrl.element)})
          })
        )
      })     
  ])
}

module.exports = charWithPoint;
